export default {
	sec_10: {
		title: {
			one: '기업에 ',
			two: '관해',
		},
		desc: {
			one: '보안과 관리는 저희가 합니다.',
			two: '운영에만 신경 쓰시면 됩니다.',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '가맹점 관리도',
				two: '자동으로',
			},
			desc: {
				one: '아직도 일일이 관리를 하고 계신가요?',
				two: 'JP WORLD PAY만 사용하면 자동으로',
			},
		},
		two: {
			title: {
				one: '회원가입하고',
				two: '가맹점 등록 끝',
			},
			desc: {
				one: '가맹점 등록 끝',
				two: '사용료 없이 평생 무료 사용.',
			},
		},
	},
};
